<template>
    <Modal :visible="visible" @close="$emit('close')">
        <template #header>
            <p class="modalTitle">Reserve Seat {{ seat.id }}</p>
        </template>
        <template #body>
            <div v-if="!isBulk" class="single-reserve">
                <label>Reservation Date</label>
                <input
                type="date"
                v-model="reservationDate"
                :min="minDate"
                :max="maxDate"
                />
            </div>
            <div v-else class="bulk-reserve">
                <label>Start Date</label>
                <input type="date" v-model="startDate" :min="minDate" :max="maxDate" />
                <label>End Date</label>
                <input type="date" v-model="endDate" :min="startDate" :max="maxDate" />
            </div>
            <div class="rm-toggle-wrapper">
                <span>Reserve in bulk</span>
                <input
                  type="checkbox"
                  id="isBulk-toggle"
                  v-model="isBulk"
                  class="rm-toggle-input"
                />
                <label for="isBulk-toggle" class="rm-toggle-label"></label>
            </div>
            <div class="rm-toggle-wrapper">
                <span>Reserve for guest</span>
                <input
                type="checkbox"
                id="guestMode-toggle"
                v-model="guestMode"
                class="rm-toggle-input"
                />
                <label for="guestMode-toggle" class="rm-toggle-label"></label>
            </div>
            <div v-if="guestMode" class="guestNameWrap">
                <input type="text" v-model="guestName" placeholder="Guest Name" />
            </div>
            <div v-if="errors" class="error">{{ errors }}</div>
        </template>
        <template #footer>
            <div class="btnWrap">
                <button @click="$emit('close')" class="submit-button cancelBtn">Cancel</button>
                <button @click="onConfirm" class="submit-button">Confirm</button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import api from "@/services/api";
export default {
  watch: {
    visible(newVal) {
      if (newVal) {
        this.reservationDate = this.initialDate;
        this.startDate = this.initialDate;
        this.endDate = this.initialDate;
        this.isBulk = false;
        this.errors = null;
      }
    },
  },
  name: "ReservationModal",
  components: { Modal },
  props: {
    visible: { type: Boolean, required: true },
    seat: { type: Object, required: true },
    initialDate: { type: String, required: true },
  },
  computed: {
    // 本日
    minDate() {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    },
    // 本日から30日後
    maxDate() {
      const d = new Date();
      d.setDate(d.getDate() + 30);
      return d.toISOString().slice(0, 10);
    },
  },
  data() {
    return {
      isBulk: false,
      reservationDate: this.initialDate,
      startDate: this.initialDate,
      endDate: this.initialDate,
      errors: null,
      guestMode: false,
      guestName: "",
    };
  },
  methods: {
    async onConfirm() {
      this.errors = null;
      try {
        if (!this.isBulk) {
          await api.post("/seats/reserve/", {
            date: this.reservationDate,
            seat_number: this.seat.id,
            guest_name: this.guestMode ? this.guestName : null,
          });
        } else {
          if (this.endDate < this.startDate)
            throw new Error("End date must be on or after start date");
          const { data } = await api.post("/seats/seat-reservations/bulk/", {
            seat_number: this.seat.id,
            start_date: this.startDate,
            end_date: this.endDate,
            guest_name: this.guestMode ? this.guestName : null,
          });
          if (data.failed && data.failed.length) {
            this.errors = `The following dates could not be reserved: ${data.failed.join(
              ", "
            )}`;
            return;
          }
        }
        this.$emit("confirmed");
      } catch (e) {
        const detail = e.response?.data?.detail || "";
        if (
          detail.includes("You can reserve only one seat per day.") &&
          !this.guestMode
        ) {
          this.errors = "You can only reserve one seat per day for yourself.";
        } else {
          this.errors = detail || e.message || "Failed to reserve";
        }
      }
    },
  },
};
</script>

<style>
    .modal-header, .modal-footer{
        padding: 0!important;
        border-bottom: none !important;
    }
    .modal-container{
        padding: 2rem;
    }
</style>
<style scoped>
    .error {
        color: red;
        margin-top: 8px;
    }
    .single-reserve,
    .bulk-reserve {
        margin-top: 1rem;
        align-items: center;
    }
    .btnWrap {
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .modalTitle{
        font-size: 20px;
        color: var(--blue);
        font-weight: 600;
        text-align: center;
        margin:0;
        & span{
            font-size: 0.9em;
        }
    }
    .single-reserve,.bulk-reserve{
        display: flex;
        justify-content: space-between;
    }
    .guestNameWrap>input {
        margin-top: 1rem;
        width: calc(100% - 2rem);
        padding: 1rem;
    }
    .submit-button {
        background: var(--grad90);
        width: 100%;
        max-width: 300px;
        padding: 1rem;
        border: none;
        color: white;
        border-radius: 10px;
        margin: 0;
        display: block;

        &.cancelBtn{
            background: none;
            border: 1px solid var(--blue);
            color: var(--blue);
            max-width: 150px;
            margin-right: 1rem;
        }

        .submit-button:disabled {
            background: #cccccc;
            cursor: inherit;
        }
    }

    /* トグルスイッチのスタイル */
    .rm-toggle-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1rem;
        padding-top: 1rem;
        width: 100%;
        border-top: 1px dashed var(--midLightBlue);
        & span {
            color: var(--blue);
            font-size: 14px;
            font-weight: 600;
        }
    }
    .rm-toggle-label {
        position: relative;
        display: block;
        width: 60px;
        height: 29px;
        background: #ccc;
        border-radius: 23px;
        cursor: pointer;
        transition: background 0.2s;

        &:after {
            content: "OFF";
            position: absolute;
            top: 3px;
            left: 3px;
            padding: 3px 6px;
            background: white;
            border-radius: 100px;
            transition: transform 0.2s;
            font-size: 14px;
            color: gray;
            font-weight: 600;
        }
    }
    .rm-toggle-input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        z-index: 1;

        &:checked + .rm-toggle-label {
            background: var(--blue);
        }
        &:checked + .rm-toggle-label:after {
            content: "ON";
            color: var(--blue);
            transform: translateX(20px);
        }
    }
    input[type="date"],
    input[type="text"],
    select {
        padding: 1rem;
    }
</style>
